import { ModuleAccessProvider } from "../context/ModuleAccess/ModuleAccessContext";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Route as RouterRoute, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Signup from "../pages/Signup";
import Login from "../pages/Login";
import Connections from "../pages/Connections";
import SettingsCustom from "../pages/SettingsCustom";
import Financeiro from "../pages/Financeiro";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts";
import ContactImportPage from "../pages/Contacts/import";
import ChatMoments from "../pages/Moments";
import Queues from "../pages/Queues";
import Tags from "../pages/Tags";
import MessagesAPI from "../pages/MessagesAPI";
import Helps from "../pages/Helps";
import ContactLists from "../pages/ContactLists";
import ContactListItems from "../pages/ContactListItems";
import Companies from "../pages/Companies";
import QuickMessages from "../pages/QuickMessages";
import { AuthProvider } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";
import Schedules from "../pages/Schedules";
import Campaigns from "../pages/Campaigns";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Prompts from "../pages/Prompts";
import AgentEditor from "../pages/AgentEditor";
import KnowledgeBases from "../pages/KnowledgeBases";
import AiUsage from "../pages/AiUsage";
import AllConnections from "../pages/AllConnections";
import Reports from "../pages/Reports";
import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
// import Integrations from '../pages/Integrations';
// import GoogleCalendarComponent from '../pages/Integrations/components/GoogleCalendarComponent';
import FlowBuilder from "../pages/FlowBuilder";
import FlowDefault from "../pages/FlowDefault";
import CampaignsPhrase from "../pages/CampaignsPhrase";
import Subscription from "../pages/Subscription";
import QueueIntegration from "../pages/QueueIntegration";
import Files from "../pages/Files";
import ToDoList from "../pages/ToDoList";
import Kanban from "../pages/Kanban";
import TagsKanban from "../pages/TagsKanban";
import Crm from "../pages/Crm";
import ForgotPassword from "../pages/ForgetPassWord";
import ResetPassword from "../pages/ResetPassword";
import { USER_FEATURES } from "../helpers/userFeatureAccess";
import { DataDeletion, PrivacyPolicy, TermsOfUse } from "../pages/Legal";

// 🔹 NOVO: página de Configurações Globais (Mercado Pago + SMTP)
import GlobalConfig from "../pages/GlobalConfig";

const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  return (
    <BrowserRouter>
      <Switch>
        <RouterRoute
          exact
          path={["/politica-de-privacidade", "/privacy-policy"]}
          component={PrivacyPolicy}
        />
        <RouterRoute
          exact
          path={["/exclusao-de-dados", "/data-deletion"]}
          component={DataDeletion}
        />
        <RouterRoute
          exact
          path={["/termos-de-uso", "/terms-of-service"]}
          component={TermsOfUse}
        />
        <RouterRoute>
          <AuthProvider>
            <ModuleAccessProvider>
              <TicketsContextProvider>
                <Switch>
                  <Route exact path="/login" component={Login} />
                  <Route exact path="/signup" component={Signup} />
                  <Route
                    exact
                    path="/forgot-password"
                    component={ForgotPassword}
                  />
                  <Route
                    exact
                    path="/reset-password"
                    component={ResetPassword}
                  />
                  <WhatsAppsProvider>
                    <LoggedInLayout>
                      <Route
                        exact
                        path="/financeiro"
                        component={Financeiro}
                        isPrivate
                      />

                      <Route
                        exact
                        path="/companies"
                        component={Companies}
                        isPrivate
                      />
                      <Route exact path="/" component={Dashboard} isPrivate />
                      <Route
                        exact
                        path="/tickets/:ticketId?"
                        component={TicketResponsiveContainer}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/connections"
                        component={Connections}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/quick-messages"
                        component={QuickMessages}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/todolist"
                        component={ToDoList}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/schedules"
                        component={Schedules}
                        isPrivate
                      />
                      <Route exact path="/tags" component={Tags} isPrivate />
                      <Route
                        exact
                        path="/contacts"
                        component={Contacts}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/contacts/import"
                        component={ContactImportPage}
                        isPrivate
                      />
                      <Route exact path="/helps" component={Helps} isPrivate />
                      <Route exact path="/users" component={Users} isPrivate />
                      <Route
                        exact
                        path="/messages-api"
                        component={MessagesAPI}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/settings"
                        component={SettingsCustom}
                        isPrivate
                      />

                      {/* 🔹 NOVO: rota para Configurações Globais da plataforma */}
                      <Route
                        exact
                        path="/global-config"
                        component={GlobalConfig}
                        isPrivate
                      />

                      <Route
                        exact
                        path="/queues"
                        component={Queues}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/reports"
                        component={Reports}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/queue-integration"
                        component={QueueIntegration}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/announcements"
                        component={Annoucements}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/phrase-lists"
                        component={CampaignsPhrase}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/flowbuilders"
                        component={FlowBuilder}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/flowbuilder/:id?"
                        component={FlowBuilderConfig}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/chats/:id?"
                        component={Chat}
                        isPrivate
                      />
                      <Route exact path="/files" component={Files} isPrivate />
                      <Route
                        exact
                        path="/moments"
                        component={ChatMoments}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/Kanban"
                        component={Kanban}
                        isPrivate
                        userFeature={USER_FEATURES.KANBAN}
                      />
                      <Route
                        exact
                        path="/TagsKanban"
                        component={TagsKanban}
                        isPrivate
                        userFeature={USER_FEATURES.KANBAN}
                      />
                      <Route
                        exact
                        path="/crm"
                        component={Crm}
                        isPrivate
                        userFeature={USER_FEATURES.CRM}
                      />
                      <Route
                        exact
                        path={["/prompts/new", "/prompts/:promptId/edit"]}
                        component={AgentEditor}
                        userFeature={USER_FEATURES.AI}
                        isPrivate
                      />
                      <Route
                        exact
                        path="/prompts"
                        component={Prompts}
                        isPrivate
                        userFeature={USER_FEATURES.AI}
                      />
                      <Route
                        exact
                        path="/knowledge-bases"
                        component={KnowledgeBases}
                        isPrivate
                        userFeature={USER_FEATURES.AI}
                      />
                      <Route
                        exact
                        path="/ai-usage"
                        component={AiUsage}
                        isPrivate
                        userFeature={USER_FEATURES.AI}
                      />
                      <Route
                        exact
                        path="/allConnections"
                        component={AllConnections}
                        isPrivate
                      />
                      {showCampaigns && (
                        <>
                          <Route
                            exact
                            path="/contact-lists"
                            component={ContactLists}
                            isPrivate
                          />
                          <Route
                            exact
                            path="/contact-lists/:contactListId/contacts"
                            component={ContactListItems}
                            isPrivate
                          />
                          <Route
                            exact
                            path="/campaigns"
                            component={Campaigns}
                            isPrivate
                          />
                          <Route
                            exact
                            path="/campaign/:campaignId/report"
                            component={CampaignReport}
                            isPrivate
                          />
                          <Route
                            exact
                            path="/campaigns-config"
                            component={CampaignsConfig}
                            isPrivate
                          />
                        </>
                      )}
                    </LoggedInLayout>
                  </WhatsAppsProvider>
                </Switch>
                <ToastContainer position="top-center" autoClose={3000} />
              </TicketsContextProvider>
            </ModuleAccessProvider>
          </AuthProvider>
        </RouterRoute>
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
